import React from 'react';

const ErrorModal = ({ message }) => {
  return (
    <div className=" flex -mb-7">
      <p className=' text-red-600'>{" "+ message}</p>
      {/* <button>Close</button> */}
    </div>
  );
};

export default ErrorModal;